// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"32ee3f4b","157":"18a88005"}[chunkId] + ".chunk.css";
};